export let stateOptions = [
  {
    value: "SOLID",
    label: "固体",
  },
  {
    value: "SEMISOLID",
    label: "半固体",
  },
  {
    value: "LIQUID",
    label: "液体",
  },
  {
    value: "GAS",
    label: "气体",
  },
  {
    value: "POWDER",
    label: "粉末",
  },
  {
    value: "GRAIN",
    label: "颗粒",
  },
  {
    value: "CRYSTALLINE_POWDER",
    label: "结晶性粉末",
  },
  {
    value: "GEL",
    label: "凝胶",
  },
  {
    value: "OTHER_SHAPE",
    label: "其他",
  },
];
export let colorOtions = [
  {
    value: "RED",
    label: "红色",
  },
  {
    value: "WHITE",
    label: "白色",
  },
  {
    value: "COLOURLESS",
    label: "无色",
  },
  {
    value: "COLORLESS_TRANSPARENT",
    label: "无色透明",
  },
  {
    value: "SILVER",
    label: "银色",
  },
  {
    value: "YELLOW",
    label: "黄色",
  },
  {
    value: "MILKY_WHITE",
    label: "乳白色",
  },
  {
    value: "FAINT_YELLOW",
    label: "淡黄色",
  },
  {
    value: "LIGHT_YELLOW",
    label: "浅黄色",
  },
  {
    value: "BLACK",
    label: "黑色",
  },
  {
    value: "GRAY",
    label: "灰色",
  },
  {
    value: "BLUE",
    label: "蓝色",
  },
  {
    value: "GREEN",
    label: "绿色",
  },
  {
    value: "TAN",
    label: "褐色",
  },
  {
    value: "BROWN",
    label: "棕色",
  },
  {
    value: "PINK",
    label: "粉色",
  },
  {
    value: "RED_TAN",
    label: "红褐色",
  },
  {
    value: "BRICK_RED",
    label: "砖红色",
  },
  {
    value: "LIGHT_PINK",
    label: "浅粉色",
  },
  {
    value: "OFF_WHITE",
    label: "类白色",
  },
  {
    value: "OTHER_COLOR",
    label: "其他",
  },
];
export let packOptions = [
  {
    value: "GLASS_BOTTLE",
    label: "玻璃瓶",
  },
  {
    value: "PLASTIC_BOTTLE",
    label: "塑料瓶",
  },
  {
    value: "PLASTIC_BAG",
    label: "塑料袋",
  },
  {
    value: "ALUMINUM_PLATE",
    label: "铝板",
  },
  {
    value: "AMPOULE_BOTTLE",
    label: "安瓿瓶",
  },
  {
    value: "SELF_SEALING_BAG",
    label: "自封袋",
  },
  {
    value: "CENTRIFUGE_TUBE",
    label: "离心管",
  },
  {
    value: "STERILE_BAG",
    label: "无菌袋",
  },
  {
    value: "TIN_PAPER_BAG",
    label: "锡纸袋",
  },
  {
    value: "GAS_SAMPLING_BAG",
    label: "气体采样袋",
  },
  {
    value: "KRAFT_PAPER_BAG",
    label: "牛皮纸袋",
  },
  {
    value: "PAPER_BAG",
    label: "纸袋",
  },
  {
    value: "CARTON",
    label: "纸盒",
  },
  {
    value: "OTHER_PACK",
    label: "其他",
  },
];
export let storageOptions = [
  {
    value: "COLD_STORAGE",
    label: "冷藏",
  },
  {
    value: "ORDINARY_TEMPERATURE",
    label: "常温",
  },
  {
    value: "DRY",
    label: "干燥",
  },
  {
    value: "SEAL",
    label: "密封",
  },
  {
    value: "FREEZING",
    label: "冷冻",
  },
  {
    value: "AVOID_LIGHT",
    label: "避光",
  },
  {
    value: "SHADE",
    label: "阴凉处",
  },
  {
    value: "DRYER",
    label: "干燥器",
  },
  {
    value: "FREEZING_MINUS_EIGHTY",
    label: "冷冻（-80℃）",
  },
  {
    value: "OTHER_STORAGE",
    label: "其他",
  },
];
export let deliverOptions = [
  {
    value: "PAPER",
    label: "纸质报告",
  },
  {
    value: "DATA",
    label: "电子版数据",
  },
  {
    value: "MOBILE",
    label: "移动端",
  },
  {
    value: "ELECTRONIC",
    label: "电子版",
  },
];
export let specificationModelOptions = [
  {
    value: "ONE_MILLILITER",
    label: "1ml",
  },
  {
    value: "FIVE_MILLILITER",
    label: "5ml",
  },
  {
    value: "TEN_MILLILITER",
    label: "10ml",
  },
  {
    value: "FIFTY_MILLILITER",
    label: "50ml",
  },
  {
    value: "FIVE_HUNDRED_MILLILITER",
    label: "500ml",
  },
  {
    value: "ONE_LITER",
    label: "1L",
  },
  {
    value: "ONE_GRAM",
    label: "1g",
  },
  {
    value: "TWO_GRAM",
    label: "2g",
  },
  {
    value: "ZERO_POINT_TWO_GRAM",
    label: "0.2g",
  },
  {
    value: "ZERO_POINT_ONE_GRAM",
    label: "0.1g",
  },
  {
    value: "ZERO_POINT_FIVE_GRAM",
    label: "0.5g",
  },
  {
    value: "FIVE_GRAM",
    label: "5g",
  },
  {
    value: "TEN_GRAM",
    label: "10g",
  },
  {
    value: "TWENTY_GRAM",
    label: "20g",
  },
  {
    value: "FIFTY_GRAM",
    label: "50g",
  },
  {
    value: "OTHER_SPECIFICATION_MODEL",
    label: "其他",
  },
  {
    value: "DUMBBELL_TYPE_SPECIMEN",
    label: "哑铃型试样",
  },
  {
    value: "STRIP_SPECIMEN",
    label: "长条形试样",
  },
  {
    value: "TYPE_TWO_SPECIMEN",
    label: "2型试样",
  },
  {
    value: "BAR",
    label: "棒材",
  },
  {
    value: "CYLINDRICAL",
    label: "圆柱形",
  },
  {
    value: "STRIP",
    label: "长条",
  },
  {
    value: "BOARD",
    label: "板材",
  },
  {
    value: "RIGHT_ANGLE_TEAR_SPECIMEN",
    label: "直角撕裂试样",
  },
  {
    value: "TROUSER_TEAR_SPECIMEN",
    label: "裤型撕裂试样",
  },
];
